import React, { useState, useEffect, FC, FormEvent } from "react"
import { connect } from "react-redux"
import {
  createPlaylistTitle,
  getMyPlaylists,
} from "../../../store/actions/playlist"
import { addToPlaylist } from "../../../store/actions/playlist"
import { resetSelected } from "../../../store/actions/track"
import { RootState } from "../../../store/reducers"
import { Playlist } from "../../../models/playlist"
import { Track } from "../../../models/track"

interface Props {
  playlists: Playlist[]
  selected: Track
  tags: string[]
  createPlaylistTitle: Function
  addToPlaylist: Function
  resetSelected: Function
  getMyPlaylists: Function
  username: string
}

const PlaylistsModal: FC<Props> = ({
  playlists,
  selected,
  tags,
  createPlaylistTitle,
  addToPlaylist,
  resetSelected,
  getMyPlaylists,
  username,
}) => {
  useEffect(() => {
    document
      .getElementById("playlists-modal")
      ?.addEventListener("hidden", () => {
        resetSelected()
      })

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const [showForm, toggleForm] = useState(false)
  const [mess, setMess] = useState("")
  const [playlistData, setPlaylistData] = useState({
    title: "",
    tag: "",
    availability: "public",
  })

  const onChange = (e: FormEvent<HTMLInputElement | HTMLSelectElement>) => {
    setPlaylistData({
      ...playlistData,
      [e.currentTarget.id]: e.currentTarget.value,
      availability: e.currentTarget.id === "public" ? "public" : "private",
    })
  }

  const onSubmit = (e: FormEvent) => {
    e.preventDefault()
    let { title, tag, availability } = playlistData
    if (!title) {
      // UIkit.modal.dialog(
      //   `<p class="uk-modal-body">Playlist title is required</p>`
      // );
      setMess(`Playlist title is required`)
      setTimeout(() => {
        setMess("")
      }, 3000)
    } else {
      if (!availability) {
        availability = "public"
      }
      if (!tag) {
        tag = "custom"
      }
      createPlaylistTitle({
        title,
        tag,
        available: availability === "public",
        selected,
        username,
      })

      setPlaylistData({
        title: "",
        tag: "",
        availability: "public",
      })
      toggleForm(!showForm)
    }
  }

  return (
    <div id="playlists-modal" data-uk-modal>
      <div className="uk-modal-dialog uk-border-rounded">
        <button
          className="uk-modal-close-default"
          type="button"
          data-uk-close
        ></button>

        <div className="uk-modal-header">
          <h2 className="uk-modal-title">Playlists</h2>
        </div>

        <div className="uk-modal-body" data-uk-overflow-auto>
          <ul className="uk-list">
            {playlists &&
              playlists.map(({ title, id }) => {
                return (
                  <li
                    style={{ cursor: "pointer", textTransform: "capitalize" }}
                    key={id}
                    onClick={() => addToPlaylist({ selected, id })}
                  >
                    {title}
                  </li>
                )
              })}
          </ul>
          <button
            onClick={() => toggleForm(!showForm)}
            className="uk-button uk-margin"
          >
            Create playlist
          </button>

          {showForm && (
            <form onSubmit={onSubmit}>
              <div className="uk-margin-small-bottom">
                <label className="uk-form-label app-text">Playlist title</label>
                <input
                  type="text"
                  className="uk-input"
                  value={playlistData.title}
                  id="title"
                  onChange={onChange}
                  placeholder="Party mix"
                />
              </div>
              <div className="uk-form-controls uk-margin-small-bottom">
                <label className="uk-form-label app-text">Tag</label>
                <select onChange={onChange} id="tag" className="uk-select">
                  <option value="custom">custom</option>
                  {tags &&
                    tags.map((tag, i) => {
                      return (
                        <option key={i} value={tag}>
                          {tag}
                        </option>
                      )
                    })}
                </select>
              </div>
              <div className="uk-margin">
                <div className="uk-form-label">Make this</div>
                <div className="uk-form-controls">
                  <label>
                    <input
                      className="uk-radio"
                      type="radio"
                      id="public"
                      name="av"
                      value="public"
                      onChange={onChange}
                    />
                    Public
                  </label>
                  <label style={{ marginLeft: "10px" }}>
                    <input
                      className="uk-radio"
                      type="radio"
                      id="private"
                      value="private"
                      name="av"
                      onChange={onChange}
                    />
                    Private
                  </label>
                </div>
              </div>
              <div>
                {mess && (
                  <div className="feedback uk-margin-medium">{mess}</div>
                )}
              </div>
              <input
                type="submit"
                className="uk-button-primary uk-button uk-border-rounded"
              />
            </form>
          )}
        </div>
        <div className="uk-modal-footer uk-text-right">
          <button
            className="uk-button uk-button-default uk-modal-close"
            type="button"
          >
            CLose
          </button>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state: RootState) => ({
  playlists: state.data.myPlaylists,
  selected: state.songs.selected,
  tags: state.data.tags,
  username: state.auth.user.username,
})

const mapDispatchToProps = {
  createPlaylistTitle,
  addToPlaylist,
  resetSelected,
  getMyPlaylists,
}

export default connect(mapStateToProps, mapDispatchToProps)(PlaylistsModal)
